import React, { useEffect, useState } from 'react';
import { Modal } from '@ofself/shell';
import { useToast } from '../../components/common';
import { Note } from '../../components/nucleus/Inspector';
import { SheetFoot, FootButton } from '../../components/nucleus/SheetFoot';
import { historyOf } from '../nucleus/RealmsModel';
import { ago, whenOf } from '../../nucleus/format';

// The two small sheets Realms and Access open: a name to give (a fork, a new
// identity) and a grant's history. A failure is a toast, and the sheet stays
// open so nothing typed is lost.

export function NameModal({ title, lead, verb, placeholder, initial = '', onSubmit, onClose }) {
    const toast = useToast();
    const [name, setName] = useState(initial);
    const [busy, setBusy] = useState(false);
    const submit = async () => {
        if (!name.trim() || busy) return;
        setBusy(true);
        try {
            await onSubmit(name.trim());
            onClose();
        } catch (e) {
            toast.error(e?.message || `Could not ${verb.toLowerCase()}`);
            setBusy(false);
        }
    };
    return (
        <Modal title={title} lead={lead} onClose={onClose} size="md">
            <input
                className="realms-field"
                value={name}
                placeholder={placeholder}
                aria-label="Name"
                autoFocus
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            />
            <SheetFoot>
                <FootButton onClick={onClose}>Cancel</FootButton>
                <FootButton primary disabled={!name.trim()} busy={busy} onClick={submit}>{verb}</FootButton>
            </SheetFoot>
        </Modal>
    );
}

// A grant's ledger, newest first: each change by name, as +/− chips.
export function HistoryModal({ profile, schemaNames, load, onClose }) {
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        let live = true;
        load(profile)
            .then((j) => { if (live) setRows((j?.history || j?.events || []).map((e) => historyOf(e, schemaNames, profile.entityType))); })
            .catch((e) => { if (live) setError(e?.message || 'Could not read its history.'); });
        return () => { live = false; };
    }, [profile, schemaNames, load]);
    return (
        <Modal title={`${profile.label} · history`} onClose={onClose} size="md">
            <div className="realms-history">
                {error && <Note tone="live">{error}</Note>}
                {rows?.length === 0 && <Note>Nothing recorded yet.</Note>}
                {rows?.map((r, i) => (
                    <div key={i} className="realms-history__row">
                        <div className="realms-history__what">
                            <span>{r.title}</span>
                            {r.chips.length > 0 && (
                                <span className="realms-history__chips">
                                    {r.chips.map((c, j) => <span key={j} className={`realms-diff is-${c.tone}`}>{c.text}</span>)}
                                </span>
                            )}
                        </div>
                        <time title={whenOf(r.at, { year: true }) || undefined}>{ago(r.at, { never: '—' })}</time>
                    </div>
                ))}
            </div>
            <SheetFoot><FootButton primary onClick={onClose}>Done</FootButton></SheetFoot>
        </Modal>
    );
}
